import MyUtil from '../../MyUtil';
import MyService from '../../service';

const VehiclePartnerApi = {
  getAllVehiclePartner: async (option) => {
    try {
      const response = await MyService.getRequestData(
        '/vehicle-partner/backend',
        option
      );
      return response.data;
    } catch (e) {
      return [];
    }
  },

  createVehiclePartner: async (vehicle) => {
    let result = null;
    result = await MyService.postRequestData('/vehicle-partner', vehicle);
    return result;
  },
  deleteVehiclePartner: async (id) => {
    const result = await MyService.putRequestData(
      '/vehicle-partner/delete-vehicle-partner',
      { vhc_part_id: id }
    );
    if (result == null || result.code != 'success') {
      throw new Error('Không thể xóa xe mã ' + id + '. Vui lòng thử lại sau!');
    }

    return result.data;
  },
  editVehiclePartner: async (vehicle) => {
    let result = null;
    result = await MyService.putRequestData(
      '/vehicle-partner/edit-vehicle-partner',
      vehicle
    );

    return result;
  },
  updateSimple: async (vhc_part_id, vhc_part_hide) => {
    let result = null;
    result = await MyService.putRequestData('/vehicle-partner/update/', {
      vhc_part_hide,
      vhc_part_id,
    });

    return result;
  },
  updateFeatured: async (vhc_part_id, isFeatured) => {
    let result = null;
    result = await MyService.putRequestData('/vehicle-partner/update/', {
      isFeatured,
      vhc_part_id,
    });

    return result;
  },
  getDetailVehicle: async (vhc_part_id) => {
    let vehicle;
    await MyService.getRequestData(
      '/vehicle-partner/get-detail-vehicle-partner',
      { vhc_part_id }
    )
      .then((result) => (vehicle = result.data))
      .catch((err) => console.log(err));

    if (vehicle && vehicle.part && vehicle.vhc)
      return MyUtil.convertVehicle(vehicle);
    return vehicle;
  },
  getDetailVehicleNoConverst: async (vhc_part_id) => {
    let vehicle = {};
    await MyService.getRequestData(
      '/vehicle-partner/get-detail-vehicle-partner',
      { vhc_part_id }
    )
      .then((result) => (vehicle = result.data))
      .catch((err) => console.log(err));
    return vehicle;
  },
  getVehicleByOption: async (option) => {
    let vehicles = [];
    await MyService.getRequestData(
      '/vehicle-partner/get-vehicle-by-option',
      option
    )
      .then((result) => (vehicles = result.data))
      .catch((err) => console.log(err));
    return vehicles;
  },
};
export default VehiclePartnerApi;
